<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="table-container" *ngIf="activityData">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <span class="fa fa-search form-control-feedback"></span>
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>

    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="message.dataGridAdmin"
      (click)="openReorder()" (keydown.enter)="openReorder()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
        <path style="fill:'#FFFFFF'"
          d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
      </svg>
      <span class="reload_text text-white">Settings</span>
    </div>

    <div class="">
      <div class="action-buttons-container d-flex gap-2">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openAddPopup()"
          (keydown.enter)="openAddPopup()" matTooltip="Add Actions"
          *ngIf="message.showActionsActionButtons && aesthetic()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
          (keydown.enter)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
          (keydown.enter)="openAuditTrail('overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshGrid()"
          (keydown.enter)="refreshGrid()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!qualityService.activity.phaseIIInvestigationReqd">
    <table class="dynamic-table-container" aria-describedby="table-description">
      <th style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div>
            <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div style="margin-left: 5px;">
            <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="parentCheckBox" (change)="onParentChanged($event)">
          </div>
        </div>
      </th>
      <th class="grid-header-container" (focus)="focusEmpty()"
        *ngFor="let riskTable of columnLists.fieldColumnarray; let ix = index;" [ngStyle]="{'min-width': riskTable.width,'max-width': riskTable.width,'overflow': 'hidden',
                                'text-overflow': 'ellipsis',
                                'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssFunction(0)">
        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
          <span>{{ riskTable.fieldColumnarray }}</span>
          <div class="d-flex gap-2 align-items-center">
            <div (click)="sortColumn(columnLists.columnsListarray[ix],riskTable)"
              (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],riskTable)">
              <img class="cursor-click" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
                alt="sort" />
            </div>
          </div>
        </div>
      </th>
      <th class="sticky-col first-col"></th>
      <tr>
        <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
        <td *ngFor=" let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
          [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
          class="sticky-dynamic-col1" (mouseover)="cssFunction(0)" (focus)="focusEmpty()">
          <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
              (input)="columnFilter(columnLists.columnsListarray[ix], $event)" /> </div>
        </td>
      </tr>
      <tr *ngFor="let list of pagedItems let idx = index;">
        <td style="min-width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div>
              <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="list.childCheckBox"
                (change)="onChildChanged($event, list, idx)">
            </div>
          </div>
        </td>
        <td *ngFor="let key of columnLists.columnsListarray1; let i = index;" class="sticky-dynamic-row1"
          (focus)="focusEmpty()" (click)="openEditPopup(list,i)" (keydown.enter)="openEditPopup(list,i)"
          (mouseover)="cssFunction(i)"
          [ngStyle]="{'min-width': key.width[i]==undefined?'200px':key.width[i],'max-width': key.width[i]==undefined?'200px':key.width[i],'overflow': 'hidden', 'text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <span *ngIf="key.dataType=='CHECKBOX'">
            <div class="gridCheckBoxes">
              <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                height="20">
              <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" alt="No"
                width="20" height="20">
            </div>
          </span>
          <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(list,key.columnsListarray)">
                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                <span class="ms-1">View</span>
              </button>
            </div>
          </span>
          <span
            *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'  && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa'">{{
            list[key.columnsListarray] }}</span>
          <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray]}}</span>
        </td>
        <td class="sticky-col first-col">
          <div class="action-icons">
            <span *ngIf="message.showActionsActionButtons && aesthetic()">
              <i class="fa-solid fa-pencil" matTooltip="Edit Actions" style="margin-left: 5px;"
                (click)="openEditPopup(list,0)" (keydown.enter)="openEditPopup(list,0)"
                *ngIf="message.showActionsActionButtons"></i>
            </span>
            <i class="fa-solid fa-clipboard" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail"
              style="margin-left: 5px;" (click)="openAuditTrail('individual',list)"
              (keydown.enter)="openAuditTrail('individual',list)"></i>
          </div>
        </td>
      </tr>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <mat-tab-group *ngIf="qualityService.activity.phaseIIInvestigationReqd" selectedIndex="0" mat-stretch-tabs
    class="activitytab mat-tab-container mat-elevation-z4" animationDuration="0ms"
    (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex">
    <mat-tab *ngFor="let tab of tabs" label='{{tab.tab_name}}'>
      <ng-template mat-tab-label>
        <span>
          <img [src]="tab.tab_icon" alt="risk" width="20" height="20">
          <i class='{{tab.tab_icon}}' style="font-size: 18px;" aria-hidden="true"></i> </span>&nbsp;
        <span>{{tab.tab_name}}</span>
      </ng-template>

      <table class="dynamic-table-container" aria-describedby="table-description" style="margin: 10px;">
        <th style="min-width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div>
              <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;">
              <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="parentCheckBox" (change)="onParentChanged($event)">
            </div>
          </div>
        </th>
        <th class="grid-header-container" (focus)="focusEmpty()"
          *ngFor="let riskTable of columnLists.fieldColumnarray; let ix = index;" [ngStyle]="{'min-width': riskTable.width,'max-width': riskTable.width,'overflow': 'hidden',
                                'text-overflow': 'ellipsis',
                                'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssFunction(0)">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>{{ riskTable.fieldColumnarray }}</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn(columnLists.columnsListarray[ix],riskTable)"
                (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],riskTable)">
                <img class="cursor-click" src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
                  alt="sort" />
              </div>
            </div>
          </div>
        </th>
        <th class="sticky-col first-col"></th>
        <tr>
          <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
          <td (focus)="focusEmpty()"
            *ngFor=" let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
            [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
            class="sticky-dynamic-col1" (mouseover)="cssFunction(0)">
            <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                (input)="columnFilter(columnLists.columnsListarray[ix], $event)" /> </div>
          </td>
        </tr>
        <tr *ngFor="let list of pagedItems let idx = index;">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="list.childCheckBox"
                  (change)="onChildChanged($event, list, idx)">
              </div>
            </div>
          </td>
          <td (focus)="focusEmpty()" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" (click)="openEditPopup(list,i)" (keydown.enter)="openEditPopup(list,i)"
            (mouseover)="cssFunction(i)"
            [ngStyle]="{'min-width': key.width[i]==undefined?'200px':key.width[i],'max-width': key.width[i]==undefined?'200px':key.width[i],'overflow': 'hidden', 'text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" alt="No"
                  width="20" height="20">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData(list,key.columnsListarray)">
                  <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                  <span class="ms-1">View</span>
                </button>
              </div>
            </span>
            <span
              *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'  && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa'">{{
              list[key.columnsListarray] }}</span>
            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray]}}</span>
          </td>
          <td class="sticky-col first-col">
            <div class="action-icons">
              <span *ngIf="message.showActionsActionButtons && aesthetic()">
                <i class="fa-solid fa-pencil" matTooltip="Edit Actions" style="margin-left: 5px;"
                  (click)="openEditPopup(list,0)" (keydown.enter)="openEditPopup(list,0)"
                  *ngIf="message.showActionsActionButtons"></i>
              </span>
              <i class="fa-solid fa-clipboard" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail"
                style="margin-left: 5px;" (click)="openAuditTrail('individual',list)"
                (keydown.enter)="openAuditTrail('individual',list)"></i>
            </div>
          </td>
        </tr>
      </table>
      <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
          <div class="d-flex align-items-center gap-3">
            <div class="pagination_text mt-3">
              {{ showingRowsText }}
              1-{{ perPage }} of {{ collectionSize | number }}
            </div>
            <div>
              <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
              </ngb-pagination>
            </div>
            <div ngbDropdown class="mt-3">
              <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                ngbDropdownToggle>
                {{ perPage }}
                <i class="ms-1 fa-solid fa-chevron-down"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                <button ngbDropdownItem (click)="paginationCall(50)">50</button>
              </div>
              per page
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
    </div>
    <div class="frozen-popup-content">
      <div class="row">
        <div class="col-md-4">
          <div class="mb-2 d-flex">
            <div class="w-50">
              <label for="email"><b>{{qualityService.activity.oostType}} ID :</b></label>
            </div>
            <div class="w-50">
              <span class="tooltip-style" matTooltip="{{qualityService.activity.oosId}}">
                {{qualityService.activity.oosId}}
              </span>
            </div>
          </div>

          <div class="mb-2 d-flex">
            <div class="w-50">
              <label for="email"><b>{{qualityService.activity.oostType}} Status :</b></label>
            </div>
            <div class="w-50">{{qualityService.activity.status}}</div>
          </div>

          <div class="mb-2 d-flex">
            <div class="w-50">
              <label for="email"><b>Owner :</b></label>
            </div>
            <div class="w-50">{{qualityService.activity.ownerUserName}}</div>
          </div>

          <div class="mb-2 d-flex">
            <div class="w-50">
              <label for="email"><b>Expected Closure Date :</b></label>
            </div>
            <div class="w-50">
              {{qualityService.activity.expcetedClosureOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="row">
            <div><label for="email"><b>{{qualityService.activity.oostType}}&nbsp;Description :</b> </label>
            </div>
            <div class="row d-flex align-items-center">
              <div class="hideToolbar col-sm-11">
                <st-editor [(ngModel)]="qualityService.activity.oosDescription" [config]="excludeButtons"
                  style="min-height: 100px !important;" [spellcheck]="true" [disabled]="true"></st-editor>
              </div>
              <div class="col-sm-1 angular-editor-edit"
                (click)="openEditor('{{qualityService.activity.oostType}} + Description', 'eye')"
                (keydown.enter)="openEditor('{{qualityService.activity.oostType}} + Description', 'eye')">
                <i class="fa fa-eye eye"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr style="color: #cfcfcf;">

    <div style="max-height: 400px; overflow-y: scroll; overflow-x: hidden; margin: 15px;" *ngIf="dynamicLabel">
      <div class="row">

        <!-- Initial Details  -->
        <fieldset class="border p-2 field-set">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Plan Details</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-6">
              <div> <!-- Action Name -->
                <label id="actionName-validation" for="email"> {{dynamicLabel['ACTION_NAME']?.fieldName}} </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['ACTION_NAME']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ACTION_NAME']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <input class="input-filed-continers" type="text" placeholder="" [(ngModel)]="action.actionName"
                [disabled]="isPlanFrozen">
            </div>

            <div class="col-md-6" [hidden]="dynamicLabel['ACTION_DESCRIPTION']?.isRemovable == 'Y'">
              <div>
                <label for="email">
                  {{ dynamicLabel['ACTION_DESCRIPTION']?.fieldName }}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['ACTION_DESCRIPTION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ACTION_DESCRIPTION']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>

              <div class="row d-flex align-items-center">
                <!-- Editor -->
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="action.actionDescription" [config]="config"
                    style="min-height: 100px !important;" [spellcheck]="true" [disabled]="isPlanFrozen"
                    (paste)="onPaste($event)">
                  </st-editor>
                </div>

                <!-- Edit icon -->
                <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Action Description', 'edit')"
                  (keydown.enter)="openEditor('Action Description', 'edit')" *ngIf="!isPlanFrozen">
                  <i class="far fa-edit"></i>
                </div>
              </div>
            </div>


            <div class="col-md-3" *ngIf="visibleEditButton">
              <div>
                <label for="email">{{dynamicLabel['STATUS']?.fieldName}}</label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['STATUS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['STATUS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <input class="input-filed-continers" type="text" placeholder="" [(ngModel)]="action.status"
                [disabled]="true">
            </div>

            <div class="col-md-3" id="search-container">
              <div><!-- Assigned To -->
                <label id="assignedTo-validation" for="email"> {{dynamicLabel['ASSIGNED_TO']?.fieldName}} </label>
                <span class="mandatory-symbol">*</span>
                <label *ngIf="message.showSwitchUser" for="email" (click)="searchAssignTo('switch')"
                  (keydown.enter)="searchAssignTo('switch')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Yes" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['ASSIGNED_TO']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ASSIGNED_TO']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div style="display: flex; justify-content: center;">
                <div class="col-sm-11" style="position: relative;">
                  <input id="participantUserName" class="input-filed-continers" style="cursor: not-allowed;" type="text"
                    [(ngModel)]="action.assignedTo" [disabled]="true">
                </div>
                <div class="col-sm-1" style="padding-left: 2%; cursor: pointer;" (click)="searchAssignTo('search')"
                  (keydown.enter)="searchAssignTo('search')" *ngIf="!isPlanFrozen">
                  <i class="fa fa-search"></i>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div><!-- Target Date -->
                <label id="targetDate-validation" for="email"> {{dynamicLabel['TARGET_DATE']?.fieldName}} </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['TARGET_DATE']?.fieldNotes"
                  [matTooltip]="dynamicLabel['TARGET_DATE']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="action.targetDate" [disabled]="isPlanFrozen">
            </div>

            <div class="col-md-3" [hidden]="dynamicLabel['RESPONSIBLE_DEPARTMENT']?.isRemovable == 'Y'">
              <div><!-- Department -->
                <label id="responsible-dept" for="email"> {{dynamicLabel['RESPONSIBLE_DEPARTMENT']?.fieldName}} </label>
                <span style="float:right" *ngIf="dynamicLabel['RESPONSIBLE_DEPARTMENT']?.fieldNotes"
                  [matTooltip]="dynamicLabel['RESPONSIBLE_DEPARTMENT']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.responsibleDepartment"
                (closed)="departmentSearchText=''" (click)="focusSearch('focus-r-dept')"
                (keydown.enter)="focusSearch('focus-r-dept')" [disabled]="isPlanFrozen"
                [ngClass]="{'odd-item-mat-select':isResponsibleDepartmentOdd==action.responsibleDepartment}">
                <input type="search" id="focus-r-dept" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" (onSelectionChange)="onResponsibleDepartmentSelect($event,null)"
                  [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of departmentDropdown| assessmentSearch :departmentSearchText"
                  (onSelectionChange)="onResponsibleDepartmentSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <!-- Action Name -->
              <div>
                <label for="email">{{dynamicLabel['PLAN_NO_OF_ANALYST']?.fieldName}}</label>
                <span class="mandatory-symbol">*</span>
              </div>
              <input class="input-filed-continers" type="number" [min]="0" placeholder=""
                [(ngModel)]="action.planNoOfAnalyst" [disabled]="isPlanFrozen"
                (keypress)="validateNumberFields($event)">
            </div>
            de
            <div class="col-md-3">
              <div>
                <label for="email"> {{dynamicLabel['ACTION_PLAN_REVIEWER']?.fieldName}} </label>
                <label for="email" *ngIf="message.showSwitchUser" for="email" (click)="openswitchuser('planreviewer')"
                  (keydown.enter)="openswitchuser('planreviewer')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" alt="Switch"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['ACTION_PLAN_REVIEWER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ACTION_PLAN_REVIEWER']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.actionPlanReviewer"
                (closed)="planReviewerSearchText=''" (click)="focusSearch('focus-plan-reviewer')"
                (keydown.enter)="focusSearch('focus-plan-reviewer')">
                <input type="search" id="focus-plan-reviewer" class="dropdownsearchstyle"
                  [(ngModel)]="planReviewerSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of reviewerDropdown | assessmentSearch :planReviewerSearchText"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div>
                <label for="email"> {{dynamicLabel['ACTION_PLAN_APPROVER']?.fieldName}} </label>
                <label for="email" *ngIf="message.showSwitchUser" for="email" (click)="openswitchuser('planapprover')"
                  (keydown.enter)="openswitchuser('planapprover')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" alt="Switch"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['ACTION_PLAN_APPROVER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ACTION_PLAN_APPROVERreviewer']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.actionPlanApprover"
                (closed)="planApproverSearchText=''" (click)="focusSearch('focus-plan-approver')"
                (keydown.enter)="focusSearch('focus-plan-approver')">
                <input type="search" id="focus-plan-approver" class="dropdownsearchstyle"
                  [(ngModel)]="planApproverSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of approverDropdown | assessmentSearch :planApproverSearchText"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" [hidden]="!this.action.reviewedByUser">
              <div>
                <label for="email"> {{dynamicLabel['REVIEWER']?.fieldName}} </label>
                <label for="email" *ngIf="message.showSwitchUser" for="email" (click)="openswitchuser('reviewer')"
                  (keydown.enter)="openswitchuser('reviewer')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" alt="Switch"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['REVIEWER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['REVIEWER']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.reviewedByUser" (closed)="reviewUserTxt=''"
                (click)="focusSearch('reviewUserSearch')" (keydown.enter)="focusSearch('reviewUserSearch')"
                [disabled]="true" [ngClass]="{'odd-item-mat-select':isReviewerOdd==action.reviewedByUser}">
                <input type="search" id="reviewUserSearch" class="dropdownsearchstyle" [(ngModel)]="reviewUserTxt"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of reviewerDropdown| assessmentSearch :reviewUserTxt"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" [hidden]="!this.action.approvedByUser">
              <div><label for="email">
                  <!-- Approver -->{{dynamicLabel['APPROVER']?.fieldName}}
                </label>
                <label for="email" *ngIf="message.showSwitchUser" for="email" (click)="openswitchuser('approver')"
                  (keydown.enter)="openswitchuser('approver')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="email" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['APPROVER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['APPROVER']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.approvedByUser"
                (closed)="approveUserUserTxt=''" (click)="focusSearch('approveUserUserSearch')"
                (keydown.enter)="focusSearch('approveUserUserSearch')" [disabled]="true"
                [ngClass]="{'odd-item-mat-select':isApproverOdd==action.approvedByUser}">
                <input type="search" id="approveUserUserSearch" class="dropdownsearchstyle"
                  [(ngModel)]="approveUserUserTxt" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of approverDropdown| assessmentSearch :approveUserUserTxt"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" [hidden]="!this.action.deferReviewedByUser">
              <div>
                <label id="defer-reviewer" for="email"> {{dynamicLabel['DEFER_REVIEWER']?.fieldName}} </label>
                <label for="email" *ngIf="message.showSwitchUser" for="email" (click)="openswitchuser('deferReviewer')"
                  (keydown.enter)="openswitchuser('deferReviewer')">
                  <a><img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" alt="switch"
                      height="25"></a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_REVIEWER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_REVIEWER']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>

              <mat-select [ngClass]="{'odd-item-mat-select': oddDeferReviewer == action.deferReviewedByUser}" matInput
                placeholder="Select" [(ngModel)]="action.deferReviewedByUser" (closed)="deferReviewUserTxt=''"
                (click)="focusSearch('deferReviewUserSearch')" (keydown.enter)="focusSearch('deferReviewUserSearch')"
                [disabled]="true">
                <input type="search" id="deferReviewUserSearch" class="dropdownsearchstyle"
                  [(ngModel)]="deferReviewUserTxt" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onDeferReviewerSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of deferReviewerDropdown| assessmentSearch :deferReviewUserTxt"
                  (onSelectionChange)="onDeferReviewerSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3" [hidden]="!this.action.deferApprovedByUser">
              <div>
                <label for="email">
                  {{dynamicLabel['DEFER_APPROVER']?.fieldName}}
                </label>
                <label *ngIf="message.showSwitchUser" for="email" (click)="openswitchuser('deferApprover')"
                  (keydown.enter)="openswitchuser('deferApprover')">
                  <a>
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="switch" width="25"
                      height="25">
                  </a>
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_APPROVER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_APPROVER']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select [ngClass]="{'odd-item-mat-select': oddDeferApprover == action.deferApprovedByUser}" matInput
                placeholder="Select" [(ngModel)]="action.deferApprovedByUser" (closed)="deferApproveUserTxt=''"
                (click)="focusSearch('focus-d2-approver')" (keydown.enter)="focusSearch('focus-d2-approver')"
                [disabled]="true">
                <input type="search" id="focus-d2-approver" class="dropdownsearchstyle"
                  [(ngModel)]="deferApproveUserTxt" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onDeferApproverSelect($event,null)">Un-select</mat-option>
                <mat-option *ngFor="let item of deferApproverDropdown| assessmentSearch :deferApproveUserTxt"
                  (onSelectionChange)="onDeferApproverSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3">
              <div><!-- Target Date -->
                <label id="overdueDate-validation" for="email">
                  {{dynamicLabel['OVERDUE_NOTIFICATION_SENT_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['OVERDUE_NOTIFICATION_SENT_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['OVERDUE_NOTIFICATION_SENT_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="action.overdueNotificationSentOn" [disabled]="isPlanFrozen">
            </div>

            <div class="col-md-3">
              <div><!-- Target Date -->
                <label id="dueReminderDate-validation" for="email"> {{dynamicLabel['DUE_REMINDER_SENT_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['DUE_REMINDER_SENT_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DUE_REMINDER_SENT_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="action.dueReminderSentOn" [disabled]="isPlanFrozen">
            </div>

            <div class="col-md-3">
              <div>
                <label for="email">
                  {{dynamicLabel['INVESTIGATION_TYPE']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['INVESTIGATION_TYPE']?.fieldNotes"
                  [matTooltip]="dynamicLabel['INVESTIGATION_TYPE']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.investigationType"
                (closed)="investigationTechniqueSearchText=''" (click)="focusSearch('focus-technique')"
                (keydown.enter)="focusSearch('focus-technique')">
                <input type="search" id="focus-technique" class="dropdownsearchstyle"
                  [(ngModel)]="investigationTechniqueSearchText" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option
                  *ngFor="let item of investigationTechniqueDropDown | assessmentSearch :investigationTechniqueSearchText"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-6" [hidden]="dynamicLabel['INVESTIGATION_PLAN']?.isRemovable == 'Y'">
              <div>
                <label for="email">
                  <!-- Description -->{{dynamicLabel['INVESTIGATION_PLAN']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['INVESTIGATION_PLAN']?.fieldNotes"
                  [matTooltip]="dynamicLabel['INVESTIGATION_PLAN']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="d-flex row">
                <textarea type="text" class="input-filed-textarea" rows="3" [(ngModel)]="action.investigationPlan"
                  [disabled]="isPlanFrozen"></textarea>
              </div>
            </div>

            <div class="col-md-6" [hidden]="dynamicLabel['INVESTIGATION_TOOL']?.isRemovable == 'Y'">
              <div>
                <label for="email">
                  <!-- Description -->{{dynamicLabel['INVESTIGATION_TOOL']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['INVESTIGATION_TOOL']?.fieldNotes"
                  [matTooltip]="dynamicLabel['INVESTIGATION_TOOL']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="d-flex row">
                <input class="input-filed-continers" type="text" placeholder="" [(ngModel)]="action.investigationTool"
                  [disabled]="isPlanFrozen">
              </div>
            </div>

            <div class="col-md-6"
              [hidden]="!(dynamicLabel['JUSTIFICATION']?.isRemovable != 'Y' && action.actionPerformed)">
              <!-- Additional Remark -->
              <div>
                <label id="justification-validation" for="email">{{dynamicLabel['JUSTIFICATION']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['JUSTIFICATION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['JUSTIFICATION']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [disabled]="isPlanFrozen"
                [(ngModel)]="action.justification"></textarea>
            </div>

            <div class="col-md-3" [hidden]="!(action.actionPerformed && (visibleEditButton))">
              <label id="actionCompletedOn-validation" for="email"> {{dynamicLabel['ACTION_COMPLETED_ON']?.fieldName}}
              </label>
              <span style="float:right" *ngIf="dynamicLabel['ACTION_COMPLETED_ON']?.fieldNotes"
                [matTooltip]="dynamicLabel['ACTION_COMPLETED_ON']?.fieldNotes">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
              </span>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="action.actionCompletedOn" [disabled]="isPlanFrozen">
            </div>

            <div class="col-md-3"
              [hidden]="dynamicLabel['REVIEW_REQUESTED_ON']?.isRemovable == 'Y' || !action.reviewRequestedOn">
              <div><label for="email">
                  <!-- Review Requested On -->{{dynamicLabel['REVIEW_REQUESTED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['REVIEW_REQUESTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['REVIEW_REQUESTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">{{action.reviewRequestedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}</div>
            </div>

            <div class="col-md-3"
              [hidden]="dynamicLabel['REVIEW_COMPLETED_ON']?.isRemovable == 'Y' || !action.reviewCompletedOn">
              <div><label for="email">
                  <!-- Review Completed On -->{{dynamicLabel['REVIEW_COMPLETED_ON']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['REVIEW_COMPLETED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['REVIEW_COMPLETED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">{{action.reviewCompletedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}</div>
            </div>

            <div class="col-md-6"
              [hidden]="dynamicLabel['REVIEW_COMMENTS']?.isRemovable == 'Y' || !action.reviewComments">
              <!-- Review Comments -->
              <div>
                <label for="email">{{dynamicLabel['REVIEW_COMMENTS']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['REVIEW_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['REVIEW_COMMENTS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [(ngModel)]="action.reviewComments"
                [disabled]="true"></textarea>
            </div>

            <div class="col-md-3"
              [hidden]="dynamicLabel['APPROVAL_REQUESTED_ON']?.isRemovable == 'Y' || !action.approvalRequestedOn">
              <!-- Approval Requested On -->
              <div>
                <label for="email">{{dynamicLabel['APPROVAL_REQUESTED_ON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['APPROVAL_REQUESTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['APPROVAL_REQUESTED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">{{action.approvalRequestedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}</div>
            </div>

            <div class="col-md-3"
              [hidden]="dynamicLabel['APPROVAL_COMPLETED_ON']?.isRemovable == 'Y' || !action.approvalCompletedOn">
              <!-- Approval Completed On -->
              <div>
                <label for="email">{{dynamicLabel['APPROVAL_COMPLETED_ON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['APPROVAL_COMPLETED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['APPROVAL_COMPLETED_ON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <div class="px-2 input-filed-continers" style="align-content: center;">{{action.approvalCompletedOn |
                date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}</div>
            </div>

            <div class="col-md-6"
              [hidden]="dynamicLabel['APPROVAL_COMMENTS']?.isRemovable == 'Y' || !action.approvalComments">
              <!-- Approval Comments -->
              <div>
                <label for="email">{{dynamicLabel['APPROVAL_COMMENTS']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['APPROVAL_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['APPROVAL_COMMENTS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50"
                [(ngModel)]="action.approvalComments" [disabled]="true"></textarea>
            </div>

            <div class="col-md-6" [hidden]="dynamicLabel['DEFER_REASON']?.isRemovable == 'Y' || !action.deferReason">
              <!-- Review Comments -->
              <div>
                <label for="email">{{dynamicLabel['DEFER_REASON']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['DEFER_REASON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DEFER_REASON']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [(ngModel)]="action.deferReason"
                [disabled]="true"></textarea>
            </div>
          </div>
        </fieldset>

        <!-- Initial Details  -->
        <fieldset class="border p-2 field-set" *ngIf="action.status == 'In Progress' || action.performedActionDetails">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">Execution Details</span>
          </legend>

          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-3">
              <!-- Action Name -->
              <div>
                <label for="email">{{dynamicLabel['EXECUTION_NO_OF_ANALYST']?.fieldName}}</label>
                <span class="mandatory-symbol">*</span>
              </div>
              <input class="input-filed-continers" type="number" [min]="0" placeholder=""
                [(ngModel)]="action.executionNoOfAnalyst" [disabled]="isExecutionFrozen"
                (keypress)="validateNumberFields($event)">
            </div>
            <div class="col-md-3">
              <!-- Analyser -->
              <div>
                <label for="email">{{dynamicLabel['ANALYSED_BY_USER']?.fieldName}}</label>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="action.analysedBy" (closed)="analyserSearchText=''"
                (click)="focusSearch('analyser-search')" (keydown.enter)="focusSearch('analyser-search')"
                [disabled]="isExecutionFrozen">
                <input type="search" id="analyser-search" class="dropdownsearchstyle" [(ngModel)]="analyserSearchText"
                  matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of analyserDropDown| assessmentSearch :analyserSearchText"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-md-2" [hidden]="!visibleEditButton">
              <div>
                <label for="email">
                  <!-- Action Performed -->{{dynamicLabel['ACTION_PERFORMED']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['ACTION_PERFORMED']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ACTION_PERFORMED']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <mat-slide-toggle color="primary" [(ngModel)]="action.actionPerformed" [disabled]="isExecutionFrozen">
                <span class="active-inActive-container" *ngIf="action.actionPerformed==true"
                  [ngStyle]="action.actionPerformed==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
                <span *ngIf="action.actionPerformed==false"
                  [ngStyle]="action.actionPerformed==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>

            <div class="col-md-5" [hidden]="!(visibleEditButton && action.actionPerformed)">
              <!-- Performed Action Details -->
              <div>
                <label id="performedActionDetails-validation" for="email">
                  {{dynamicLabel['PERFORMED_ACTION_DETAILS']?.fieldName}}
                </label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['PERFORMED_ACTION_DETAILS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['PERFORMED_ACTION_DETAILS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [disabled]="isExecutionFrozen"
                [(ngModel)]="action.performedActionDetails"></textarea>
            </div>

            <div class="col-md-5">
              <div>
                <label id="results" for="email">{{dynamicLabel['INVESTIGATION_RESULTS']?.fieldName}}</label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['INVESTIGATION_RESULTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['INVESTIGATION_RESULTS']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [disabled]="isExecutionFrozen"
                [(ngModel)]="action.investigationResults"></textarea>
            </div>

            <div class="col-md-5">
              <div>
                <label id="root-cause" for="email">{{dynamicLabel['ROOT_CAUSE']?.fieldName}}</label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['ROOT_CAUSE']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ROOT_CAUSE']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [disabled]="isExecutionFrozen"
                [(ngModel)]="action.rootCause"></textarea>
            </div>

            <div class="col-md-5">
              <div>
                <label for="email">{{dynamicLabel['IMPACT_ASSESSMENT']?.fieldName}}</label>
                <span style="float:right" *ngIf="dynamicLabel['IMPACT_ASSESSMENT']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMPACT_ASSESSMENT']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [disabled]="isExecutionFrozen"
                [(ngModel)]="action.impactAssessment"></textarea>
            </div>

            <div class="col-md-2">
              <div>
                <label id="capa" for="email"> Is Capa Required? </label>
              </div>
              <mat-slide-toggle color="primary" [(ngModel)]="action.isCapaReqd" [disabled]="isExecutionFrozen">
                <ng-container *ngIf="action.isCapaReqd; else no">
                  <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>

            <div class="col-md-5" *ngIf="action.isCapaReqd">
              <div>
                <!-- Delay Logging -->
                <label id="capa-details" for="email">
                  {{dynamicLabel['CAPA_DETAILS']?.fieldName}}
                </label>
                <span style="float:right" *ngIf="dynamicLabel['CAPA_DETAILS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['CAPA_DETAILS']?.fieldNotes">
                  <img [src]="qualityService.noteIcon" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="col-sm-11">
                  <input class="input-filed-continers" type="text" [matTooltip]="action.capaDetails"
                    [disabled]="isExecutionFrozen" [(ngModel)]="action.capaDetails">
                </div>
                <div class="col-sm-1 search-icon-div">
                  <button class="search-user" style="font-size: 1.3em" matTooltip="Add or Map CAPA" (click)="mapCapa()"
                    *ngIf="!action.capaDetails" [disabled]="isExecutionFrozen">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="search-user" style="font-size: 1.3em" matTooltip="Unmap CAPA" (click)="unmapCapa()"
                    *ngIf="action.capaDetails" [disabled]="isExecutionFrozen">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-5">
              <div>
                <label for="email">{{dynamicLabel['CONCLUSION']?.fieldName}}</label>
                <span class="mandatory-symbol">*</span>
                <span style="float:right" *ngIf="dynamicLabel['CONCLUSION']?.fieldNotes"
                  [matTooltip]="dynamicLabel['CONCLUSION']?.fieldNotes">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </div>
              <textarea type="text" class="input-filed-textarea" rows="3" cols="50" [disabled]="isExecutionFrozen"
                [(ngModel)]="action.conclusion"></textarea>
            </div>
          </div>
        </fieldset>
      </div>

      <div mat-dialog-actions class="btn-align">
        <div class="button-continer" *ngFor="let button of buttonList" style="margin-left: 10px;">
          <button *ngIf="button == 'Cancel' && button != '' " mat-stroked-button class="cancelButton"
            (click)="cancelAddAndEditFunction()">
            {{button}}</button>
          <button *ngIf="button == 'Save' && button != ''" mat-stroked-button class="addButton"
            (click)="addAndEditFunction(action)">
            {{button}}</button>
          <button *ngIf="button != 'Cancel' && button != '' && button != 'Save'" mat-stroked-button class="addButton"
            (click)="dynamicButtonClick(button)"> {{button}}</button>
        </div>
      </div>

      <div class="form-template ActivityPage" *ngIf="this.visibleEditButton" id="Documents" style="margin-top:1%;">
        <div class="menu-container">
          <div class="row menu-row-container">
            <div class="col-sm-6 gridName-container">
              <span class="gridName">Documents</span>
            </div>
          </div>
        </div>
        <app-task-documents [activity]="this.objForDocuments"></app-task-documents>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #confirmWithReasonPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelFunc()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ buttonLabel }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="">
      <div class="row px-3">
        <div class="col-sm-12"
          *ngIf="buttonLabel =='Review'|| buttonLabel ==='Approve' || buttonLabel ==='Plan Review' || buttonLabel ==='Plan Approve'">
          <div><label id="reviewAndapprove-validation" for="email">{{buttonLabel}}</label><span
              class="mandatory-symbol">*</span></div>
          <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedStatus">
            <mat-radio-button class="tp-radio-button" *ngFor="let status of reviewStatus" [value]="status">
              {{status}}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="col-md-12 fieldStyle3" *ngIf="isEsignRequired">
          <div class=""><label for="username ">User Name</label><span class="mandatory-symbol">*</span></div>
          <div class=""> <input id="username" style="height: 80% !important;" class="input-filed-continers" type="text"
              [(ngModel)]="userName" disabled></div>
        </div>
        <div class="col-md-12" *ngIf="(isEsignRequired && !isAdEnabled)">
          <div class=""><label id="password-validation" for="pass ">Password</label><span
              class="mandatory-symbol">*</span></div>
          <div class=""> <input id="EsignRequiredPassword" autocomplete="off" onpaste="return false;"
              ondrop="return false;" style="height: 80% !important;" class="input-filed-continers"
              [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste>
            <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
              <i [class]="hidePassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
            </span>
          </div>
        </div>
        <div class="col-md-12"
          *ngIf="(this.buttonLabel=='Submit for Review' || this.buttonLabel=='Submit for Approval') && this.action.reviewedByUser!=0">
          <div><label for="email">
              Reviewer<!-- {{dynamicLabel['REVIEWER']}} -->
            </label>
            <label *ngIf="message.showSwitchUser" for="email" (click)="openswitchuser('reviewer')"
              (keydown.enter)="openswitchuser('reviewer')"><a><img title="Switch User" alt="switch"
                  src="..//..//../assets/img/user-switch.png" width="25" height="25"></a></label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="action.reviewedByUser" (closed)="reviewUserTxt1=''"
            (click)="focusSearch('reviewUserSearch-dd')" (keydown.enter)="focusSearch('reviewUserSearch-dd')">
            <input type="search" id="reviewUserSearch-dd" class="dropdownsearchstyle" [(ngModel)]="reviewUserTxt1"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of reviewerDropdown| assessmentSearch :reviewUserTxt1" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-12"
          *ngIf="(this.buttonLabel=='Submit for Review' || this.buttonLabel=='Submit for Approval') && this.action.approvedByUser!=0">
          <div><label for="email">
              Approver <!--{{dynamicLabel['APPROVER']}} -->
            </label>
            <label for="email" *ngIf="message.showSwitchUser" for="email" (click)="openswitchuser('approver')"
              (keydown.enter)="openswitchuser('approver')">
              <a>
                <img title="Switch User" src="..//..//../assets/img/user-switch.png" width="25" alt="switch"
                  height="25">
              </a>
            </label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="action.approvedByUser"
            (closed)="approveUserUserTxt1=''" (click)="focusSearch('approveUserUserSearch-dd')"
            (keydown.enter)="focusSearch('approveUserUserSearch-dd')">
            <input type="search" id="approveUserUserSearch-dd" class="dropdownsearchstyle"
              [(ngModel)]="approveUserUserTxt1" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of approverDropdown| assessmentSearch :approveUserUserTxt1"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="mt-2" [ngStyle]="{'border': buttonLabel=='Defer Action' ? '1px solid #cfcfcf' : '' }">
          <div class="col-md-12" *ngIf="buttonLabel=='Defer Action'">
            <div>
              <label id="reviewUser-validation" for="email"> Defer Reviewer </label>
              <span class="mandatory-symbol">*</span>
            </div>
            <mat-select matInput placeholder="Select"
              [ngClass]="{'odd-item-mat-select': oddDeferReviewer == action.deferReviewedByUser}"
              [(ngModel)]="action.deferReviewedByUser" (closed)="deferReviewUserTxt1=''"
              (click)="focusSearch('focus-d-reviewer')" (keydown.enter)="focusSearch('focus-d-reviewer')">
              <input type="search" id="focus-d-reviewer" class="dropdownsearchstyle" [(ngModel)]="deferReviewUserTxt1"
                matInput placeholder="search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onDeferReviewerSelect($event,null)">Un-select</mat-option>
              <mat-option *ngFor="let item of deferReviewerDropdown| assessmentSearch :deferReviewUserTxt1"
                (onSelectionChange)="onDeferReviewerSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-12" *ngIf="buttonLabel=='Defer Action'">
            <div>
              <label id="defer-approver" for="email"> Defer Approver </label>
              <span class="mandatory-symbol">*</span>
            </div>
            <mat-select matInput placeholder="Select"
              [ngClass]="{'odd-item-mat-select': oddDeferApprover == action.deferApprovedByUser}"
              [(ngModel)]="action.deferApprovedByUser" (closed)="deferApproveUserTxt1=''"
              (click)="focusSearch('focus-d-approver')" (keydown.enter)="focusSearch('focus-d-approver')">
              <input type="search" id="focus-d-approver" class="dropdownsearchstyle" [(ngModel)]="deferApproveUserTxt1"
                matInput placeholder="search">
              <mat-option class="unselectStyle" (onSelectionChange)="onDeferApproverSelect($event,null)"
                [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of deferApproverDropdown| assessmentSearch :deferApproveUserTxt1"
                (onSelectionChange)="onDeferApproverSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <div class="col-md-12"
            *ngIf="this.buttonLabel=='Review' || this.buttonLabel=='Approve' || this.buttonLabel=='Plan Review' || this.buttonLabel=='Plan Approve' || this.buttonLabel=='Submit for Plan Review'  || this.buttonLabel=='Submit for Plan Approve' || buttonLabel=='Defer Action'">
            <div>
              <label id="reason-validation" for="reason">
                {{buttonLabel=='Defer Action' ? 'Defer Comments' :'Comments'}}
              </label>
              <span class="mandatory-symbol" *ngIf="selectedStatus?.includes('Rejected')">*</span>
            </div>
            <textarea rows="4" class="input-filed-textarea" type="text" [(ngModel)]="reason"></textarea>
          </div>
        </div>
        <!-- Deferred -->
      </div>
      <br>
      <br
        *ngIf="(this.buttonLabel=='Submit for Review' || this.buttonLabel=='Submit for Approval') && this.action.approvedByUser!=0">
    </div>
    <div class="button-continer btn-align" mat-dialog-actions
      [ngStyle]="buttonLabel=='Defer Action' || buttonLabel=='Review' || this.buttonLabel=='Approve'?{'margin-top':'10%'} : {'':''}">
      <button *ngIf="buttonLabel != 'Defer Action'" mat-stroked-button class="addButton" (click)="confirmWithReason()">
        {{buttonLabel}}
      </button>
      <button *ngIf="buttonLabel=='Defer Action'" mat-stroked-button class="addButton" (click)="confirmWithReason()">
        Submit
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label id="deleteReason-validation" for="email">Reason for Delete</label><span
              class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="action.deleteReason"></textarea>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmValidationPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeConfirmValidationPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ buttonLabel }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <h3>You have either not performed the action or uploaded the supporting Documents.</h3>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeConfirmValidationPopup()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? includeButtons : excludeButtons"
        [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" *ngIf="allowEditing" (click)="saveEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-editor #clobViewPopup></app-editor>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmit()"></app-grid-reorder>
<app-search-users (valueEmitter)="onSearchUserEmitted()"></app-search-users>
<app-add-map-capa (valueEmitter)="onCapaEmitted()"></app-add-map-capa>
